import { ThemeProvider } from '@mui/material/styles';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './pages';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/black-han-sans/400.css';
import { Amplify } from 'aws-amplify';
import { Loading } from '@/components/Loading';
import { ForceUpdateDialog } from '@/features/forceUpdate/components/ForceUpdateDialog';
import { awsExports } from './config';
import { theme } from './theme';

Amplify.configure(awsExports);

// デプロイで旧チャンクが削除されると動的 import が失敗するため、リロードして最新版を取得する
const PRELOAD_ERROR_RELOADED_AT_KEY = 'preloadErrorReloadedAt';

window.addEventListener('vite:preloadError', (event) => {
  const reloadedAt = Number(
    sessionStorage.getItem(PRELOAD_ERROR_RELOADED_AT_KEY) ?? 0,
  );
  // リロード後も失敗が続く場合（チャンク欠落以外が原因）は無限リロードを避けてエラーに任せる
  if (Date.now() - reloadedAt < 10_000) return;
  sessionStorage.setItem(PRELOAD_ERROR_RELOADED_AT_KEY, String(Date.now()));
  event.preventDefault();
  window.location.reload();
});

// biome-ignore lint/style/noNonNullAssertion: react
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<Loading />}>
      <ThemeProvider theme={theme}>
        <ForceUpdateDialog />
        <RouterProvider router={router} />
      </ThemeProvider>
    </Suspense>
  </StrictMode>,
);
